/**
 * What every dashboard block needs from the one `GET /api/dashboard` call.
 *
 * The Worker loads each slice independently and answers `null` for any that
 * failed, so one broken widget still leaves the rest of the page — and the
 * alerts in particular — readable. Each section keeps its own skeleton, error
 * and empty state; only the fetching moved up into Dashboard.
 */
export interface SectionProps<T> {
    /** This section's slice of the dashboard response. Null when it failed. */
    data: T | null;
    loading: boolean;
    /** Set when the whole request failed, rather than just this slice. */
    error: string | null;
    /** Re-runs the one dashboard request. */
    onRetry: () => void;
}

/** A slice that came back null failed on its own, so that section shows an error. */
export function sectionError<T>(props: SectionProps<T>): string | null {
    if (props.loading) return null;
    return props.error ?? (props.data === null ? "Couldn't load this right now." : null);
}
